/**
 * ============================================================================
 * DEMO MODE — TEMPORARY, PHASE 1 (CLIENT DEMO) ONLY
 * ============================================================================
 *
 * ⚠️  REAL DATA COMES IN THE NEXT PHASE.
 *
 * The Campaign Summary dashboard is fully wired to real sources already:
 *   - live agents + calls  → `supervisor:*` Socket.IO feed (ws-gateway)
 *   - historical metrics   → GET /supervisor/campaign-summary (aggregates `calls`)
 *
 * Both work. What they do not yet have is TRAFFIC — the tenant has no call
 * history and no agents taking calls, so every table renders empty and the
 * dashboard cannot be shown to a client. Demo mode fills that gap with a
 * simulated feed driven by real MP3 recordings, so the client can see the
 * layout, the metrics, the state transitions and can actually LISTEN to a call.
 *
 * ----------------------------------------------------------------------------
 * HOW TO TURN IT OFF (next phase — this is the whole procedure)
 * ----------------------------------------------------------------------------
 *   1. Set `DEMO_MODE = false` below. That is enough: every panel falls back
 *      to the real socket feed and the real API response, because demo data is
 *      injected at exactly ONE point in the page (see CampaignSummaryPage's
 *      `useDemoOverlay` call) and nowhere else.
 *   2. Delete `./demo/` and `apps/web/public/demo-recordings/`.
 *   3. Delete this file and its two imports.
 *
 * Nothing else in the dashboard imports from `./demo/` — that is deliberate, so
 * removing the demo cannot break the real implementation.
 *
 * ----------------------------------------------------------------------------
 * WHAT IS SIMULATED vs REAL
 * ----------------------------------------------------------------------------
 *   REAL   The logged-in agent roster. The overlay uses whatever agents the
 *          live socket reports and simulates activity ON TOP of those real
 *          identities, so the client sees their own users' names — not
 *          invented ones. Only if the roster is empty does it fall back to a
 *          placeholder cast.
 *   REAL   The audio. Every playable call is an actual MP3.
 *   SIM    Call arrival/answer/end, agent state transitions, and all
 *          aggregate metrics.
 */

/**
 * Master switch. Flip to `false` to restore the real feed everywhere.
 *
 * Deliberately a plain constant rather than an env var: an env var makes it
 * possible to ship a build that is silently in demo mode, and this must be a
 * visible, reviewable source change.
 */
export const DEMO_MODE = false

/**
 * Banner text shown at the top of the dashboard whenever demo mode is on.
 *
 * Non-negotiable: a dashboard showing invented operational numbers must say so
 * on its face. Someone will screenshot this page, and the screenshot has to
 * carry the caveat with it.
 */
export const DEMO_BANNER =
  'Demo data — simulated call activity for preview. Live agent identities are real; ' +
  'call volumes, metrics and states are generated. Real-time data lands in the next phase.'
